
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-development-services-for-various-industries",
      function () {
        return require("private-next-pages/software-development-services-for-various-industries.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-development-services-for-various-industries"])
      });
    }
  